export default {
    users : null,
    subscriptions: {
        subscriptions: [],
        detailedIndex: null
    },
    basket: []
}